import { Injectable } from '@angular/core';
import { downloadBlobAsFile } from '@app/core/utils/download-blob-as-file';
import { CSV_FILE_NAME } from '@app/core/constants/csv-file-name';

export interface CsvOptions {
  utf8Bom?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CsvService {

  private blob?: Blob;

  public createBlob(body: string): void {
    this.blob = new Blob([body], { type: 'text/csv' });
  }

  public getBlob(): Blob | undefined {
    return this.blob;
  }

  public download(filename?: string): void {
    if (this.blob) {
      this.downloadFromBlob(this.blob, filename || CSV_FILE_NAME);
    }
  }

  public downloadFromBlob(blob: Blob, filename: string, options?: CsvOptions): void {
    downloadBlobAsFile(blob, filename, options);
  }
}
